import { IonCol, IonRow } from "@ionic/react";
import { Pole_t } from "../../types/pole";

interface Props {
  href: string;
  pole: Pole_t;
  arrayLength: number;
}

const Pole: React.FC<Props> = ({ href, pole, arrayLength }) => {
  return (
    <IonCol
      size-lg={(1 / arrayLength) * 12}
      size={((1 / arrayLength) * 12).toString()}
      size-sm={(1 / arrayLength) * 12}
      className="ion-justify-content-center ion-no-padding"
    >
      <IonRow className="ion-justify-content-center">
        <IonCol
          onClick={() => {
            if (typeof pole.value === "number") {
              localStorage.setItem("pole", pole.value.toString());
              window.location.href = href;
            } else window.location.href = href + "?type=" + pole.value;
          }}
          className="btn fullWidth ion-no-padding"
          size-sm="11"
          size="11"
          size-lg="11"
        >
          {pole.title}
        </IonCol>
      </IonRow>
    </IonCol>
  );
};

export default Pole;
